import styled from "styled-components";
import {
  FileCertificate,
  FileIcon,
  HoldingHandsIcon,
  HourGlassIcon,
  LeafIcon,
  UserCheckIcon,
  UserIcon,
  UserRemoveIcon,
  UsersIcon,
  WalletIcon,
} from "../../assets";


const normalize = (status = "") => status.trim().toLowerCase();


const STATUS_COLORS = {
  successful: "rgba(18, 124, 78, 0.1)",
  won: "rgba(18, 124, 78, 0.1)",
  tracking: "rgba(244, 186, 52, 0.1)",
  unsuccessful: "rgba(240, 70, 63, 0.1)",
  lost: "rgba(240, 70, 63, 0.1)",
  paid: "rgba(89, 84, 222, 0.1)",
  all: "rgba(100, 116, 139, 0.1)",
};


const ICONS = {
  successful: UserCheckIcon,
  won: UserCheckIcon,
  tracking: HourGlassIcon,
  unsuccessful: UserRemoveIcon,
  lost: UserRemoveIcon,
  paid: LeafIcon,
  all: UsersIcon,
};

const Frame1428 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.size || "48px"};
  min-width: ${(props) => props.size || "48px"};
  height: ${(props) => props.size || "48px"};
  min-height: ${(props) => props.size || "48px"};
  border-radius: 999px;
  background: ${(props) => {
    const key = normalize(props.status);
    const color = STATUS_COLORS[key] || "rgba(89, 84, 222, 0.1)";
    return `linear-gradient(-90deg, ${color}, ${color})`;
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

const StatusBadge = ({ status, size = "48px", showCustomWon = false }) => {
  const key = normalize(status);
  let icon;

  if (key === "successful" && showCustomWon) {
    icon = FileCertificate;
  } else {
    icon = ICONS[key] || WalletIcon;
  }

  // Calculate icon size as 40% of badge size
  const numericSize = parseInt(size, 10);
  const iconSize = Math.floor(numericSize * 0.5);

  return (
    <Frame1428 status={status} size={size}>
      <img src={icon} alt={status} width={iconSize} height={iconSize} />
    </Frame1428>
  );
};


export default StatusBadge;
